import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CouponService } from 'src/app/services/coupon.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { AccountService } from 'src/app/services/account.service';


@Component({
  selector: 'app-view-coupon',
  templateUrl: './view-coupon.component.html',
  styleUrls: ['./view-coupon.component.css']
})
export class ViewCouponComponent implements OnInit {
  id: any;
  coupon: any = {};
  panelOpenState: any;
  domain: any;
  subDomain: any;
  licenseId: any;
  domains: any = [];
  domainNames: any[];
  subDomainNames: any[];
  license_packages: any = [];
  licenseNames: any[];
  providers: any;
  coupon_stats: any = {};
  isDomain = false;
  isSubDomain = false;
  isLicense = false;
  isProvider = false;
  startTime;
  endTime;
  interval;
  constructor(private couponService: CouponService,
    private activatedRoute: ActivatedRoute, private router: Router,
    private commonService: CommonfilterService, private accountService: AccountService) {

      this.commonService.getServiceSectors()
      .subscribe(result => {
        this.domains = result;
      });


  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.couponService.getCouponStatistics(this.id)
        .subscribe(
          res => {
            this.coupon_stats = res;

          }
        );
      this.couponService.getCouponDetails(this.id)
        .subscribe(
          res => {
            this.coupon = res;
            // this.startTime = this.coupon.couponRules.targetDate[0].timeSlots[0].sTime;
            // this.endTime = this.coupon.couponRules.targetDate[0].timeSlots[0].eTime;
            if (this.coupon.target.providerId) {
              this.providers = this.coupon.target.providerId;
              this.isProvider = true;
            }


            if (!this.coupon.target.providerId) {
                  if (this.coupon.target.domain) {
                    this.isDomain = true;
                    if (this.coupon.target.domain.includes('ALL')) {
                      this.domainNames = this.couponService.getAllDomains();
                    } else {
                      this.domainNames = this.couponService.getTargetedDomains(this.coupon.target.domain);
                    }
                  }
                  if (this.coupon.target.subdomain) {
                    this.isSubDomain = true;
                    if ((this.coupon.target.subdomain.includes('ALL')) && (this.coupon.target.domain.includes('ALL'))) {
                      this.subDomainNames = this.couponService.getAllSubDomains();
                    } else if ((this.coupon.target.subdomain.includes('ALL')) && (!this.coupon.target.domain.includes('ALL'))) {
                      this.subDomainNames = this.couponService.getAllSubDomainNamesofDomain(this.coupon.target.domain);

                    } else {
                      this.subDomainNames = this.couponService.getTargetedSubDomainNames(this.coupon.target.subdomain);

                    }
                  }
                // });
            }

            if (this.coupon.target.licenseRequired) {
              this.isLicense = true;
              this.accountService.getLicensePackages()
                .subscribe(license => {
                  this.license_packages = license;
                  if (this.coupon.target.licenseRequired.includes(0)) {
                    this.licenseNames = this.couponService.getAllLicenseNames(this.license_packages);
                  } else {
                    this.licenseNames = this.couponService.getLicenseNames(this.coupon.target.licenseRequired, this.license_packages);
                  }
                });
            }
          }
        );
    });
  }


  goBacktoList() {
    this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });

  }

}
